module.exports = __webpack_public_path__ + "img/info-circle-info-20x20.79e58f96.svg";